/* eslint-disable camelcase */
export const Events = {
    load_page: 'load_page',
};
